import React from "react";
import { Route, Routes } from "react-router-dom";

//pages
import Home from "../components/pages/Home.jsx";
import Layout from "../components/layout/Layout.jsx";
import Login from "../components/pages/Login.jsx";
import Signup from "../components/pages/Signup.jsx";

// user components
import Dashboard from "../components/user/Dashboard.jsx";
import ProtectedRoute from "../components/layout/ProtectedRoute.jsx";
import LayoutWithoutNav from "../components/layout/LayoutWithoutNav.jsx";
import Anatomy from "../components/user/Anatomy.jsx";
import AnatomyChild from "../components/user/AnatomyChild.jsx";
import Text from "../components/user/Text.jsx";
import Images from "../components/user/Images.jsx";
import Vedios from "../components/user/Vedios.jsx";
import ImgDisc from "../components/user/ImgDisc.jsx";
import Setting from "../components/user/Setting.jsx";
import ChangePass from "../components/pages/ChangePass.jsx";
import TextSeries from "../components/user/TextSeries.jsx";
import UserSecurity from "../components/user/UserSecurity.jsx";
import Blogs from "../components/user/Blogs.jsx";
import Courses from "../components/user/Courses.jsx";
import Qbank from "../components/user/Qbank.jsx";
import VerifyOtp from "../components/pages/VerifyOtp.jsx";
import PreviousYearPaper from "../components/user/PreviousYearPaper.jsx";
import Topics from "../components/user/Topics.jsx";
import PYQTest from "../components/user/PYQTest .jsx";

function App() {
  return (
    <>
      <Routes>
        {/* Public Routes */}
        <Route element={<Layout />}>
          <Route path="/" element={<Home />} />
          <Route path="user/login" element={<Login />} />
          <Route path="user/signup" element={<Signup />} />
          <Route path="user/verify-otp" element={<VerifyOtp />} />
        </Route>

        {/* Protected with Navbar Layout */}
        <Route element={<ProtectedRoute />}>
          <Route element={<LayoutWithoutNav />}>
            <Route path="user/dashboard" element={<Dashboard />} />
            <Route path="user/subjects" element={<Qbank />} />
            <Route path="/user/subjects/:subjectId/topics" element={<Topics />} />
            <Route path="user/previous-year-papers" element={<PreviousYearPaper />} />
            <Route path="user/anatomy" element={<Anatomy />} />
            <Route path="user/images" element={<Images />} />
            <Route path="user/video" element={<Vedios />} />
            <Route path="user/setting" element={<Setting />} />
            <Route path="user/test-series" element={<TextSeries />} />
            <Route path="user/anatomy/upper-limb" element={<AnatomyChild />} />
            <Route path="user/security" element={<UserSecurity />} />
            {/* <Route path="user/blog" element={<Blogs />} /> */}
            <Route path="user/course" element={<Courses />} />
          </Route>
        </Route>

        {/* Protected but without Navbar Layout */}
        <Route element={<ProtectedRoute />}>
          <Route path="user/anatomy/text" element={<Text />} />
          <Route path="user/anatomy/discription" element={<ImgDisc />} />
          <Route path="user/changePassword" element={<ChangePass />} />
          <Route path="/pyq/test/:year" element={<PYQTest />} />
        </Route>
      </Routes>
    </>
  );
}
export default App;
